// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
}
#loader {
  display: block;
  position: relative;
  left: 50%;
  top: 50%;
  width: 150px;
  height: 150px;
  margin: -75px 0 0 -75px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #ff007a;
  animation: spin 2s linear infinite;
}
#loader {
  z-index: 1001;
}

#loader:before {
  content: "";
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #12b6b3;
  animation: spin 3s linear infinite;
}
#loader:after {
  content: "";
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #ffffff;
  animation: spin 1.5s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
#loader-wrapper .loader-section {
  position: fixed;
  top: 0;
  width: 51%;
  height: 100%;
  background: #222222;
  z-index: 1000;
}
#loader-wrapper .loader-section.section-left {
  left: 0;
}
#loader-wrapper .loader-section.section-right {
  right: 0;
}
.loaded #loader-wrapper .loader-section.section-left {
  transform: translateX(-100%);
}
.loaded #loader-wrapper .loader-section.section-right {
  transform: translateX(100%);
}
.loaded {
  visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/loader/loader.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EAEzB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EAEzB,oCAAoC;AACtC;AAaA;EACE;IAGE,uBAAuB;EACzB;EACA;IAGE,yBAAyB;EAC3B;AACF;AACA;EACE,eAAe;EACf,MAAM;EACN,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;AACA;EAGE,4BAA4B;AAC9B;AACA;EAGE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB","sourcesContent":["#loader-wrapper {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 9999;\r\n  background: rgba(0, 0, 0, 0.5);\r\n}\r\n#loader {\r\n  display: block;\r\n  position: relative;\r\n  left: 50%;\r\n  top: 50%;\r\n  width: 150px;\r\n  height: 150px;\r\n  margin: -75px 0 0 -75px;\r\n  border-radius: 50%;\r\n  border: 3px solid transparent;\r\n  border-top-color: #ff007a;\r\n  animation: spin 2s linear infinite;\r\n}\r\n#loader {\r\n  z-index: 1001;\r\n}\r\n\r\n#loader:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 5px;\r\n  left: 5px;\r\n  right: 5px;\r\n  bottom: 5px;\r\n  border-radius: 50%;\r\n  border: 3px solid transparent;\r\n  border-top-color: #12b6b3;\r\n  -webkit-animation: spin 3s linear infinite;\r\n  animation: spin 3s linear infinite;\r\n}\r\n#loader:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 15px;\r\n  left: 15px;\r\n  right: 15px;\r\n  bottom: 15px;\r\n  border-radius: 50%;\r\n  border: 3px solid transparent;\r\n  border-top-color: #ffffff;\r\n  -webkit-animation: spin 1.5s linear infinite;\r\n  animation: spin 1.5s linear infinite;\r\n}\r\n@-webkit-keyframes spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    -ms-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    -ms-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n@keyframes spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    -ms-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    -ms-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n#loader-wrapper .loader-section {\r\n  position: fixed;\r\n  top: 0;\r\n  width: 51%;\r\n  height: 100%;\r\n  background: #222222;\r\n  z-index: 1000;\r\n}\r\n#loader-wrapper .loader-section.section-left {\r\n  left: 0;\r\n}\r\n#loader-wrapper .loader-section.section-right {\r\n  right: 0;\r\n}\r\n.loaded #loader-wrapper .loader-section.section-left {\r\n  -webkit-transform: translateX(-100%);\r\n  -ms-transform: translateX(-100%);\r\n  transform: translateX(-100%);\r\n}\r\n.loaded #loader-wrapper .loader-section.section-right {\r\n  -webkit-transform: translateX(100%);\r\n  -ms-transform: translateX(100%);\r\n  transform: translateX(100%);\r\n}\r\n.loaded {\r\n  visibility: hidden;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
